<div>
     <div 
          class="alert alert-info" 
          [innerHtml]="'onThe10th' | translator: 'payment'"
          *ngIf="!showBilling"    
     >
          Selecting a default payment method on your account will automatically draft the balance due on the 10th of each month.
     </div>
     <div *ngIf="!showBilling">
          <div *ngIf="showDefaultChangedAlert" 
               id="showDefaultChangedAlert"
               name="showDefaultChangedAlert"
               class="alert alert-success">
                    <span 
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'creditCard'"  
                         [innerHtml]="'default_payment_method_changed1' | translator: 'payment'"
                    >
                         The Credit Card ending in 
                    </span> 
                    <span 
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'bankAccount'" 
                         [innerHtml]="'default_payment_method_changed3' | translator: 'payment'"
                    >
                         The ACH Debit account ending in 
                    </span> 
                    <b> {{displayDefaultPaymentMethodAccountNumber}} </b>
                    <span 
                         [innerHtml]="'default_payment_method_changed_cc' | translator: 'payment'"
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'creditCard'" 
                    >
                         is now your default payment method. The balance on your most recent invoice will be automatically be charged on the 10th of each month from this credit card.
                    </span>
                    <span 
                         [innerHtml]="'default_payment_method_changed_ach' | translator: 'payment'"
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'bankAccount'" 
                    >
                         is now your default payment method. The balance on your most recent invoice will be automatically be drafted on the 10th of each month from this bank account.
                    </span>
          </div>
          
          <div *ngIf="ShowDefaultPaymentChangeFailureAlert == true"
               id="showDefaultPaymentChangeFailureAlert"
               name="showDefaultPaymentChangeFailureAlert"
               class="alert alert-danger"
               [innerHtml]="'default_payment_method_error' | translator: 'payment'"
          >
               There was a problem setting your default payment method.
          </div>

          <div *ngIf="showRemoveCreditCardSuccess"
               id="showRemoveCreditCardSuccess"
               name="showRemoveCreditCardSuccess"
               class="alert alert-success"
          >
               <span [innerHtml]="'deleted_credit_card1' | translator: 'payment'">The Credit Card ending in</span> 
               <b> {{creditCardNumberDeleteDisplay}} </b>
               <span [innerHtml]="'deleted_credit_card2' | translator: 'payment'">has been removed.</span>
          </div>
          
          <div *ngIf="showRemoveCreditCardError"
               id="showRemoveCreditCardError"
               name="showRemoveCreditCardError"
               class="alert alert-danger"
               [innerHtml]="'remove_payment_method_error' | translator: 'payment'"
          >
               There was a problem removing your credit card account.
          </div>

          <div *ngIf="showAddMethodSuccess"
               id="showAddMethodSuccess"
               name="showAddMethodSuccess"
               class="alert alert-success"
               [innerHtml]="'add_method_success' | translator: 'payment'"
          >
               A new payment method was added to your account.
          </div>
          
          <div *ngIf="showAddMethodError"
               id="showAddMethodError"
               name="showAddMethodError"
               class="alert alert-danger"
          >
               <span [innerHtml]="'add_method_error' | translator: 'payment'">There was a problem adding your payment method. Please contact customer service at </span>
               <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>.
          </div>

          <div *ngIf="showUpdateMethodSuccess"
               id="showUpdateMethodSuccess"
               name="showUpdateMethodSuccess"
               class="alert alert-success" 
               [innerHtml]="'update_method_success' | translator: 'payment'"
          >
               Your payment method has been updated.
          </div>
          
          <div *ngIf="showUpdateMethodError"
               id="showUpdateMethodError"
               name="showUpdateMethodError"
               class="alert alert-danger" 
          >
               <span [innerHtml]="'update_method_error' | translator: 'payment'">There was a problem updating your payment method. Please contact customer service at </span>
               <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>.
          </div>			

          <button
               (click)="showBillingBox()"
               class="btn btn-primary btn-strong mb-3"
               [title]="'AddPaymentMethod' | translator: 'payment'"
               name="btnAddPaymentMethod"
               id="btnAddPaymentMethod"
               [innerHtml]="'AddPaymentMethod' | translator: 'payment'"
          >
               Add Payment Method
          </button>

          <div *ngIf="!hasPaymentMethods"
               class="fst-italic"
               [innerHtml]="'NoElectronicAvailable' | translator: 'payment'"    
          >
               No electronic payment methods available.
          </div>

          <div id="cc-list" *ngIf="hasPaymentMethods" id="activePaymentMethodContainer">
               <div ngbAccordion [closeOthers]="true"
                    class="accordion" id="accordionCreditcardContainer"
               >
                    <div ngbAccordionItem
                         class="accordion-item"
                         *ngFor="let creditCard of activePaymentMethods.creditCards; let idx = index;"
                         [id]="creditCard.Id"
                         [collapsed]="!creditCard.isDefault"
                    >
                         <h2 ngbAccordionHeader
                              [id]="'accordionCreditcardHeader-' + idx"
                              class="accordion-header h6" 
                              aria-expanded="false" 
                              [attr.aria-controls]="'activecreditcardshow-' + idx"
                              data-bs-toggle="collapse" 
                         >
                              <button ngbAccordionButton
                                   block variant="info" 
                                   class="accordion-button rounded-0 activeMethodHeaderBtn" 
                                   [ngClass]="{'collapsed': !creditCard.isDefault}"
                                   [title]="'btnCreditCardToggle' | translator: 'payment'"
                                   [id]="'activecreditcard-' + idx"
                                   [name]="'activecreditcard-' + idx"
                                   type="button" 
                                   aria-expanded="true" 
                                   [attr.data-bs-target]="'#activecreditcardshow-' + idx"
                                   [attr.aria-controls]="'activecreditcardshow-' + idx"
                              >
                                   <span class="pe-3">
                                        <span 
                                             class="text-nowrap me-2" 				 	
                                             [innerHtml]="'btnCreditCardToggle' | translator: 'payment'"
                                        >
                                             Credit Card
                                        </span>
                                        <span [title]="'('+creditCard.creditCardNumber+')'">
                                             ({{ creditCard.creditCardNumber }})
                                        </span>
                                        <span 
                                             *ngIf="creditCard.isDefault" 
                                             [innerHtml]="'default_account' | translator: 'payment'" 
                                             class="text-nowrap ms-2 fst-italic"
                                        >
                                             (Default)
                                        </span>
                                   </span>
                              </button>							
                         </h2>
                         <div ngbAccordionCollapse 
                              [id]="'activecreditcardshow-' + idx"  
                              class="accordion-collapse collapse activeCardBody" 
                              [attr.aria-labelledby]="'accordionCreditcardHeader-' + idx"		
                              role="region"					
                         >
                              <div ngbAccordionBody class="accordion-body">
                                   <div class="card-text">
                                        <span class="label-method fw-bold" [innerHtml]="'creditCardLabel' | translator: 'payment'">
                                             Credit Card:
                                        </span> 
                                        {{creditCard.creditCardNumber}}
                                   </div>
                                   <div class="card-text">
                                        <span class="label-method fw-bold" [innerHtml]="'expDateLabel' | translator: 'payment'">
                                             Card Expiration Date:
                                        </span> 
                                        {{creditCard.creditCardExpire}} 
                                        <span [hidden]="!isCreditCardExpired(creditCard)" 
                                             [innerHtml]="'expired_account' | translator: 'payment'" 
                                             class="bold fw-normal fst-italic"
                                        >
                                             - Expired
                                        </span>
                                   </div>
                                   <div class="card-text mb-3">
                                        <span class="label-method fw-bold" [innerHtml]="'cardTypeLabel' | translator: 'payment'">
                                             Card Type:
                                        </span> 
                                        {{cardTypes[creditCard.creditCardType]}}										
                                   </div>

                                   <button class="btn btn-primary mb-2 me-2" 
                                        [hidden]="!allowCreditCardEdit(creditCard.id)"
                                        (click)="showUpdateBillingBox(creditCard)"
                                        [title]="'btnUpdateExpiration' | translator: 'payment'"
                                        [id]="'btnUpdateExpiration-' + idx"
                                        [name]="'btnUpdateExpiration-' + idx"
                                        [innerHtml]="'btnUpdateExpiration' | translator: 'payment'"
                                   >
                                        Update
                                   </button>
                                   <button class="btn btn-outline-primary mb-2 me-2"
                                        [hidden]="creditCard.isDefault || isCreditCardExpired(creditCard)" 
                                        (click)="showConfirmDefaultPaymentMethodModal('creditCard', (creditCard.id))" 
                                        [innerHtml]="'btnMakeDefaultMethod' | translator: 'payment'" 
                                        [title]="'btnMakeDefaultMethod' | translator: 'payment'"
                                        [id]="'btnMakeCcDefaultMethod-' + idx"
                                        [name]="'btnMakeCcDefaultMethod-' + idx"
                                   >					
                                        Make Default
                                   </button>
                                   <button class="btn btn-danger mb-2" 
                                        [hidden]="creditCard.isDefault.toString() === 'true'"
                                        (click)="showConfirmDeleteCreditCardModal(creditCard.id)"
                                        [title]="'btnRemove' | translator: 'payment'"
                                        [id]="'btnRemove-' + idx"
                                        [name]="'btnRemove-' + idx"
                                        [innerHtml]="'btnRemove' | translator: 'payment'"
                                   >			
                                        Delete
                                   </button>
                              </div>
                         </div>
                    </div>
                    <div ngbAccordionItem
                         class="accordion-item"
                         *ngFor="let bank of activePaymentMethods.bankAccounts; let idx = index;"
                         [id]="bank.id"
                         [collapsed]="!bank.isDefault"
                    >
                         <h2 ngbAccordionHeader
                              [id]="'accordionDefaultCreditcardHeader-' + idx" 
                              class="accordion-header h6" 
                         >
                              <button ngbAccordionButton
                                   block variant="info" 
                                   class="accordion-button rounded-0 activeMethodHeaderBtn" 
                                   [title]="'btnAchDebitToggle' | translator: 'payment'"
                                   [id]="'btnAchDebitToggle-' + idx"
                                   [name]="'btnAchDebitToggle-' + idx"
                                   type="button" 
                                   data-bs-toggle="collapse" 
                                   aria-expanded="true"
                                   [attr.data-bs-target]="'#activebankshow-' + idx"
                                   [attr.aria-controls]="'activebankshow-' + idx" 									
                              >	
                                   <span 
                                        class="me-2"
                                        [title]="'btnAchDebitToggle' | translator: 'payment'" 
                                        [innerHtml]="'btnAchDebitToggle' | translator: 'payment'"
                                   >
                                        ACH Debit
                                   </span> 
                                   <span [title]="'(' + bank.acctNo + ')'">({{bank.acctNo}})</span> 
                                   <span 
                                        *ngIf="bank.isDefault" 
                                        [title]="'default_account' | translator: 'payment'" 
                                        [innerHtml]="'default_account' | translator: 'payment'" 
                                        class="ms-2 fst-italic"
                                   >
                                        (Default)
                                   </span>
                              </button>
                         </h2>
                         <div ngbAccordionCollapse [id]="'activebankshow-' + idx" 
                              class="accordion-collapse collapse activeCardBody" 
                              [ngClass]="{'show': bank.isDefault}"
                              role="region"
                              [attr.aria-labelledby]="'accordionDefaultCreditcardHeader-' + idx"	
                         >
                              <div ngbAccordionBody class="accordion-body">
                                   <div class="card-text">
                                        <span class="label-method fw-bold" [innerHtml]="'bankAcctNoLabel' | translator: 'payment'">
                                             Account No:
                                        </span> 
                                        {{bank.acctNo}}
                                   </div>
                                   <div class="card-text">
                                        <span class="label-method fw-bold" [innerHtml]="'bankRoutingNoLabel' | translator: 'payment'" >
                                             Routing No:
                                        </span> 
                                        {{bank.routeNo}}
                                   </div>
                                   <div class="card-text mb-3">
                                        <span class="label-method fw-bold" [innerHtml]="'bankNameLabel' | translator: 'payment'">
                                             Bank Name:
                                        </span> 
                                        {{bank.bankName}}
                                   </div>
                                   <button
                                        [hidden]="bank.isDefault === true" 
                                        (click)="showConfirmDefaultPaymentMethodModal('bankAccount', (bank.id))" 
                                        class="btn btn-outline-primary me-2"
                                        [innerHtml]="'btnMakeDefaultMethod' | translator: 'payment'" 
                                        [title]="'btnMakeDefaultMethod' | translator: 'payment'"
                                        [id]="'btnMakeAchDefaultMethod-' + idx"
                                        [name]="'btnMakeAchDefaultMethod-' + idx"
                                   >
                                        Make Default
                                   </button>
                              </div>
                         </div>
                    </div>
               </div>
          </div>

          <ng-template #ConfirmPaymentMethodModal let-modal>
               <div class="modal-header">
                    <h3
                         id="confirmPaymentMethodModalTitle" 
                         class="modal-title"
                         slot="header"
                         [innerHtml]="'confirmDefaultPaymentMethod' | translator: 'payment'"
                    >
                         Confirm Default Payment Method
                    </h3>
               </div>
               <div class="modal-body">
                    <p>
                         <span 
                              *ngIf="defaultPaymentMethodTypeToBeChanged === 'creditCard'" 
                              [innerHtml]="'change_default_payment_method_text1' | translator: 'payment'"
                         >
                              Do you want to make the credit card ending in
                         </span>
                         <span 
                              *ngIf="defaultPaymentMethodTypeToBeChanged === 'bankAccount'" 
                              [innerHtml]="'change_default_payment_method_text3' | translator: 'payment'"
                         >
                              Do you want to make the ACH Debit ending in 
                         </span>
                         <b>{{displayDefaultPaymentMethodAccountNumber}} </b>
                         <span [innerHtml]="'change_default_payment_method_text2' | translator: 'payment'">
                              your default payment method?
                         </span>
                    </p>
                    <p 
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'creditCard'" 
                         [innerHtml]="'ccAutoPayInfo' | translator: 'payment'"
                    >
                         Select "Ok" to use this credit card to pay your invoice balance on the 10th of each month.  
                    </p>
                    <p 
                         *ngIf="defaultPaymentMethodTypeToBeChanged === 'bankAccount'"
                         [innerHtml]="'bankAutoPayInfo' | translator: 'payment'"
                    >
                         Select "Ok" to use this bank account to pay your invoice balance on the 10th of each month.  
                    </p>
               </div>
               <div class="modal-footer">
                    <button
                         class="btn btn-primary ms-2"
                         (click)="changeDefaultPaymentMethod()"
                         [title]="'ok_button' | translator: 'base'"

                         id="btnMakeDefaultOk"
                         name="btnMakeDefaultOk"
                         [innerHtml]="'ok_button' | translator: 'base'"

                    >
                         Ok
                    </button>
                    <button
                         class="btn btn-outline-primary"
                         (click)="cancelDefaultPaymentMethodChange()"
                         [title]="'cancel_button' | translator: 'base'"
                         id="btnMakeDefaultCancel"
                         name="btnMakeDefaultCancel"
                         [innerHtml]="'cancel_button' | translator: 'base'"
                    >
                         Cancel
                    </button>
               </div>
          </ng-template>

          <ng-template #ConfirmDeleteCreditCardModal let-modal>
               <div class="modal-header">
                    <h3 
                         id="confirmDeleteCreditCardModalTitle" 
                         class="modal-title"
                         slot="header"
                         [innerHtml]="'confirmRemovePaymentMethod' | translator: 'payment'"
                    >
                         Remove payment method
                    </h3>
               </div>
               <div class="modal-body">
                    <p class="m-0">
                         <span [innerHtml]="'delete_creditcard_text1' | translator: 'payment'">
                              Are you sure you want to remove the credit card ending in 
                         </span> 
                         <b>{{creditCardNumberDeleteDisplay}}</b>?
                    </p>
               </div>
               <div class="modal-footer">
                    <button
                         class="btn btn-primary ms-2"
                         (click)="removeCreditCard()"
                         [title]="'ok_button' | translator: 'base'"

                         id="btnMakeDefaultOk"
                         name="btnMakeDefaultOk"
                         [innerHtml]="'ok_button' | translator: 'base'"

                    >
                         Ok
                    </button>
                    <button
                         class="btn btn-outline-primary"
                         (click)="closeConfirmDeleteCreditCardModal()"
                         [title]="'cancel_button' | translator: 'base'"
                         id="btnMakeDefaultCancel"
                         name="btnMakeDefaultCancel"
                         [innerHtml]="'cancel_button' | translator: 'base'"
                    >
                         Cancel
                    </button>
               </div>
          </ng-template>
     
     </div>
     <!-- Add Payment Method section -->
     <div *ngIf="showBilling && paymentsService.walletURL != ''"
          class="row"
     >
          <div class="col-12">
               <div class="card shadow-sm rounded-0 border-0" id="newsComponentFieldset" name="newsComponentFieldset">
                    <div class="card-body">				
                         <fieldset>
                              <legend class="h2">
                                   <div *ngIf="!isUpdateProcess" [innerHtml]="'AddPaymentMethod' | translator: 'payment'">
                                        Add Payment Method
                                   </div>
                                   <div *ngIf="isUpdateProcess" [innerHtml]="'UpdatePaymentMethod' | translator: 'payment'">
                                        Update Payment Method
                                   </div>
                              </legend>

                              <iframe
                                   [src]='iframeSrc'
                                   aria-label="Add Payment Method form with credit card or e-check."
                                   id="walletIframe"
                                   name="walletIframe"
                                   role="presentation" 
                                   scrolling="no" 
                              ></iframe>	
                                                                      
                         </fieldset>
                    </div>
               </div>				
          </div>
     </div>

     <div
          class="overlay"
          *ngIf="isLoading"
     >
          <h1
               class="heading"
               [innerHtml]="'Loading' | translator: 'base'"
          >Loading...</h1>
          <img [alt]="'Loading' | translator: 'base'" />
     </div>	

</div>
